import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import useLobSites from "app/components/compare/WebsiteQueryBar/useLobSites";
import useLocalStorage from "app/custom-hooks/useLocalStorage";
import { isCompareMode } from "app/UtilitiesAndConstants/UtilityFunctions/isCompareMode";

const LOB_BANNER_IN_FOLDERS_PAGE_PREF_KEY = "viewed_lob_banner_in_folders_page";

type UseLobBannerReturn = {
    mainSite: string;
    shouldShowLobBanner: boolean;
    handleCloseLobBanner: () => void;
};

export const useLobBanner = (): UseLobBannerReturn => {
    const { params } = useCurrentStateAndParams();
    const isCompare = isCompareMode();

    const keyParam = (params?.key as string) || "";
    const mainSite = isCompare && keyParam ? keyParam.split(",")[0] : keyParam;

    const { lobSites } = useLobSites({ shouldFetch: true });

    const [hasSeenLobBanner, setHasSeenLobBanner] = useLocalStorage(LOB_BANNER_IN_FOLDERS_PAGE_PREF_KEY);

    const isKeyInLobSites = useMemo(() => {
        if (!mainSite || lobSites.length === 0) {
            return false;
        }
        return lobSites.some((site) => site.name === mainSite);
    }, [lobSites, mainSite]);

    const shouldShowLobBanner = isKeyInLobSites && !hasSeenLobBanner;

    const handleCloseLobBanner = () => {
        setHasSeenLobBanner(true.toString());
    };

    return {
        mainSite,
        shouldShowLobBanner,
        handleCloseLobBanner,
    };
};
